import React, { Component } from 'react';

import PropTypes from 'prop-types';

import {
	default as AnalyticsReactContext,
	type AnalyticsReactContextInterface,
} from '@atlaskit/analytics-next-stable-react-context';

const ContextTypes = {
	getAtlaskitAnalyticsContext: PropTypes.func,
	getAtlaskitAnalyticsEventHandlers: PropTypes.func,
};

interface Props {
	children: React.ReactNode;
	/**
	 * Analytics context to pass into the modal. Can be returned from useAnalyticsContext();
	 */
	value: AnalyticsReactContextInterface;
}

/**
 * This provides both modern and legacy context. It intentionally does not attempt to capture any
 * context to re-provide as it is used at the root of the mount point's render tree.
 */
export class LinkCreateModalProvider extends Component<Props, AnalyticsReactContextInterface> {
	static contextTypes: {
		getAtlaskitAnalyticsContext: PropTypes.Requireable<(...args: any[]) => any>;
		getAtlaskitAnalyticsEventHandlers: PropTypes.Requireable<(...args: any[]) => any>;
	} = ContextTypes;
	static childContextTypes: {
		getAtlaskitAnalyticsContext: PropTypes.Requireable<(...args: any[]) => any>;
		getAtlaskitAnalyticsEventHandlers: PropTypes.Requireable<(...args: any[]) => any>;
	} = ContextTypes;

	contextValue: AnalyticsReactContextInterface;

	constructor(props: Props) {
		super(props);

		const { getAtlaskitAnalyticsContext, getAtlaskitAnalyticsEventHandlers } = this.props.value;
		this.contextValue = {
			getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
			getAtlaskitAnalyticsEventHandlers: getAtlaskitAnalyticsEventHandlers,
		};
	}

	getChildContext = (): AnalyticsReactContextInterface => {
		return this.contextValue;
	};

	render(): React.JSX.Element {
		const { children } = this.props;

		return (
			<AnalyticsReactContext.Provider value={this.contextValue}>
				{children}
			</AnalyticsReactContext.Provider>
		);
	}
}
